import {IBaseButtonDesign} from "@echo-nx/shared/common";

export interface IButtonThemeRsdDesign extends IBaseButtonDesign {
  prominent?: boolean;
  rounded?: boolean;
  titleAlign?: 'text-left' | 'text-center' | 'text-right';
}
